import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_GROUPS } from "@/helpers/waves/waves.constants";
import type { CreateWaveGroupConfigType, WaveGroupsConfig } from "@/types/waves.types";
import CreateWaveWarning from "../utils/CreateWaveWarning";
import CreateWaveGroup from "./CreateWaveGroup";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { CreateWaveInlineGroupBuilderState, CreateWaveInlineGroupPanel, CreateWaveInlineGroupRuleType } from "./createWaveInlineGroupBuilder";
export default function CreateWaveGroups(t0) {
  const $ = _c(42);
  const {
    waveName,
    waveType,
    groups,
    onGroupSelect,
    onInlineGroupCreate,
    chatEnabled,
    adminCanDeleteDrops,
    groupsCache,
    groupBuilders,
    setChatEnabled,
    setGroupBuilderPanel,
    setGroupBuilderRule,
    setGroupBuilderDraft,
    addGroupBuilderIdentity,
    removeGroupBuilderIdentity,
    resetGroupBuilder,
    setDropsAdminCanDelete
  } = t0;
  const isRestrictedGroup = !!groups.admin && !!groups.canView;
  const t1 = CREATE_WAVE_GROUPS[waveType];
  let t2;
  if ($[0] !== addGroupBuilderIdentity || $[1] !== adminCanDeleteDrops || $[2] !== chatEnabled || $[3] !== groupBuilders || $[4] !== groups || $[5] !== groupsCache || $[6] !== onGroupSelect || $[7] !== onInlineGroupCreate || $[8] !== removeGroupBuilderIdentity || $[9] !== resetGroupBuilder || $[10] !== setChatEnabled || $[11] !== setDropsAdminCanDelete || $[12] !== setGroupBuilderDraft || $[13] !== setGroupBuilderPanel || $[14] !== setGroupBuilderRule || $[15] !== t1 || $[16] !== waveName || $[17] !== waveType) {
    let t3;
    if ($[19] !== addGroupBuilderIdentity || $[20] !== adminCanDeleteDrops || $[21] !== chatEnabled || $[22] !== groupBuilders || $[23] !== groups || $[24] !== groupsCache || $[25] !== onGroupSelect || $[26] !== onInlineGroupCreate || $[27] !== removeGroupBuilderIdentity || $[28] !== resetGroupBuilder || $[29] !== setChatEnabled || $[30] !== setDropsAdminCanDelete || $[31] !== setGroupBuilderDraft || $[32] !== setGroupBuilderPanel || $[33] !== setGroupBuilderRule || $[34] !== waveName || $[35] !== waveType) {
      t3 = groupType => <CreateWaveGroup key={groupType} waveName={waveName} groupType={groupType} waveType={waveType} chatEnabled={chatEnabled} groupsCache={groupsCache} groups={groups} groupBuilder={groupBuilders[groupType]} adminCanDeleteDrops={adminCanDeleteDrops} setChatEnabled={setChatEnabled} onGroupSelect={group => onGroupSelect({
        group,
        groupType
      })} onInlineGroupCreate={onInlineGroupCreate} setGroupBuilderPanel={panel => setGroupBuilderPanel(groupType, panel)} setGroupBuilderRule={rule => setGroupBuilderRule(groupType, rule)} setGroupBuilderDraft={draft => setGroupBuilderDraft(groupType, draft)} addGroupBuilderIdentity={identity => addGroupBuilderIdentity(groupType, identity)} removeGroupBuilderIdentity={wallet => removeGroupBuilderIdentity(groupType, wallet)} resetGroupBuilder={() => resetGroupBuilder(groupType)} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
      $[19] = addGroupBuilderIdentity;
      $[20] = adminCanDeleteDrops;
      $[21] = chatEnabled;
      $[22] = groupBuilders;
      $[23] = groups;
      $[24] = groupsCache;
      $[25] = onGroupSelect;
      $[26] = onInlineGroupCreate;
      $[27] = removeGroupBuilderIdentity;
      $[28] = resetGroupBuilder;
      $[29] = setChatEnabled;
      $[30] = setDropsAdminCanDelete;
      $[31] = setGroupBuilderDraft;
      $[32] = setGroupBuilderPanel;
      $[33] = setGroupBuilderRule;
      $[34] = waveName;
      $[35] = waveType;
      $[36] = t3;
    } else {
      t3 = $[36];
    }
    t2 = t1.map(t3);
    $[0] = addGroupBuilderIdentity;
    $[1] = adminCanDeleteDrops;
    $[2] = chatEnabled;
    $[3] = groupBuilders;
    $[4] = groups;
    $[5] = groupsCache;
    $[6] = onGroupSelect;
    $[7] = onInlineGroupCreate;
    $[8] = removeGroupBuilderIdentity;
    $[9] = resetGroupBuilder;
    $[10] = setChatEnabled;
    $[11] = setDropsAdminCanDelete;
    $[12] = setGroupBuilderDraft;
    $[13] = setGroupBuilderPanel;
    $[14] = setGroupBuilderRule;
    $[15] = t1;
    $[16] = waveName;
    $[17] = waveType;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[37] !== isRestrictedGroup) {
    t3 = isRestrictedGroup && <CreateWaveWarning title="Warning: Limited Access" description={" This wave is configured with restricted access. It can only be viewed\n        and managed by the members of the \"Who can view\" and\n        \"Admin\" groups. If you are not a member of either of these\n        groups, you will not be able to access this wave."} />;
    $[37] = isRestrictedGroup;
    $[38] = t3;
  } else {
    t3 = $[38];
  }
  let t4;
  if ($[39] !== t2 || $[40] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t2}{t3}</div>;
    $[39] = t2;
    $[40] = t3;
    $[41] = t4;
  } else {
    t4 = $[41];
  }
  return t4;
}